import { lazy } from 'react';

export const ACKNOWLEDGEMENT_DIALOG = 'ACKNOWLEDGEMENT_DIALOG';
export const REAUTHORIZE_DIALOG = 'REAUTHORIZE_DIALOG';
export const EXPORT_RIPPLING_DIALOG = 'EXPORT_RIPPLING_DIALOG';
export const EXPORT_RIPPLING_CSV_DIALOG = 'EXPORT_RIPPLING_CSV_DIALOG';
export const DIMENSION_MISMATCH_DIALOG = 'DIMENSION_MISMATCH_DIALOG';
export const RIPPLING_PAYROLL_ERRORS_DIALOG = 'RIPPLING_PAYROLL_ERRORS_DIALOG';

const dialogs = {
  [ACKNOWLEDGEMENT_DIALOG]: lazy(() => import('./Acknowledgement')),
  [REAUTHORIZE_DIALOG]: lazy(() => import('./Reauthorize')),
  [EXPORT_RIPPLING_DIALOG]: lazy(() => import('./ExportRippling')),
  [EXPORT_RIPPLING_CSV_DIALOG]: lazy(() => import('./ExportRipplingCSV')),
  [DIMENSION_MISMATCH_DIALOG]: lazy(() => import('./DimensionMismatchDialog')),
  [RIPPLING_PAYROLL_ERRORS_DIALOG]: lazy(() => import('./RipplingPayrollErrors')),
};

export default dialogs;
